import React, { useState, useEffect, useMemo } from "react"
import axios from "axios";

function Rem_banner_section(props) {
    
   
    function banner_slider() {
   
        return (
            <div className="banner_slider" dangerouslySetInnerHTML={{__html: window.slider_banner }}></div>
        );
    }
    return (
 
    <section class="rem_slider_banner">
    {
            banner_slider()
    }
    </section>
    );
}

export default Rem_banner_section;